import {connect} from 'react-redux'
import Home from '../components/Home'
import {selectUserInfo} from '../../../redux/modules/session'

const mapStateToProps = state => {
  const userInfo = selectUserInfo(state)
  return {
    isLoggedIn: userInfo.isLoggedIn
  }
}

const VisibleHome = connect(
  mapStateToProps
)(Home)
export default VisibleHome



// WEBPACK FOOTER //
// ./src/domains/home/containers/VisibleHome.js